<template>
  <div>
    <el-table
      :data="users.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Channels" width="100%">
        <template slot-scope="props">
          <div v-for="(value, key) in props.row.channels" :key="new Date().getTime() + key">
            <el-tooltip v-if="value" :content="value.channelName" placement="right">
              <div class="pointer social-icon" :style="channelBgImg(key, value)"
                   @click="openPlatform(key, value)"></div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="First name" prop="first_name" sortable="custom"></el-table-column>
      <el-table-column label="Last name" prop="surname" sortable="custom"></el-table-column>
      <el-table-column label="E-mail" prop="email" sortable="custom"></el-table-column>
      <el-table-column label="Country" prop="country_of_residence" sortable="custom"></el-table-column>
      <el-table-column label="User letypevel" prop="user_level" sortable="custom">
        <template slot-scope="props">
          <el-tag class="capitalize" :type="tagType(props.row.user_level)">
            {{ props.row.user_level | underscore_to_space }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User level" prop="user_tier" sortable="custom">
        <template slot-scope="props">
          <el-tag :type="tierType(props.row.user_tier)">
            {{ tierName(props.row.user_tier) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User Wallet" prop="wallet" sortable="custom">
        <template slot-scope="props">
          {{ props.row.wallet ? '$'+props.row.wallet.toFixed(2) : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Signup date" prop="created_at" sortable="custom">
        <template slot-scope="props">
          {{ moment(props.row.created_at).format('DD MMMM YYYY') }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="150%">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button type="warning" circle size="small" icon="el-icon-edit" @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <el-button type="danger" circle size="small" icon="el-icon-close" @click="deleteU(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="float-right" background @size-change="sizeChange" @current-change="currentChange"
      :current-page.sync="users.current_page" :page-sizes="[10, 25, 50, 100]" :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper" :total="users.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import { pick as _pick } from 'lodash'

export default {
  data() {
    return {
      dialogTier: false,
      user_tier: '',
      user_channel: [],
      user_status: null,
      moment: moment
    }
  },

  computed: {
    ...mapState('permissionUsers', [
      'users',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading'
    ]),
    ...mapState('user', ['user'])
  },

  methods: {
    ...mapActions('permissionUsers', ['readPermissionUsers']),
    ...mapActions('user', [
      'delete',
      'update',
      'getCompanyAdminArtist'
    ]),
    ...mapMutations('permissionUsers', [
      'setPermissionPage',
      'setPageSize',
      'setOrdering'
    ]),
    ...mapMutations('user', ['setDialog', 'setShowWallet', 'setSelectedUser', 'setTierDialog']),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readPermissionUsers()
    },
    currentChange(page) {
      this.setPermissionPage(page)
      this.readPermissionUsers()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readPermissionUsers()
    },

    tagType(level) {
      switch (level) {
        case 'guest':
          return 'info'
        case 'user':
          return 'success'
        case 'company_admin':
          return ''
        case 'sysadmin':
          return 'danger'
        default:
          return 'warning'
      }
    },
    channelBgImg(platform) {
      let img = require(`@/assets/icons/${platform}.svg`)
      return `
        background-image:url('${img}');
        background-repeat: no-repeat;
        background-position-x: right;
        background-origin: content-box;
        background-size: 25px;
      `
    },

    openPlatform(platform, data) {
      if (platform === 'youtube') {
        window.open('https://youtube.com/channel/' + data.channelId)
      }
      else if (platform === 'instagram') {
        if (data.channelId.startsWith('https://')){
          window.open(data.channelId);
        } else {
          window.open('https://instagram.com/' + data.channelId);
        }
      }
      else if (platform === 'tiktok') {
        if (data.channelId.startsWith('https://')){
          window.open(data.channelId);
        } else {
          window.open('https://tiktok.com/' + data.channelId);
        }
      }
    },

    openEdit(user) {
      user = _pick(user, [
        'surname', 'user_level', 'user_tier', 'wallet', 'label', 'id', 'first_name',
        'email', 'country_of_residence', 'artist', 'company_admin', 'image_url', 'featured', 'permission'
      ])
      this.setShowWallet(true)
      this.setSelectedUser(JSON.parse(JSON.stringify(user)))
      this.setDialog(true)
    },

    deleteU(id) {
      this.$confirm(
        'You will permanently delete this user. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id).then(() => {
            this.readPermissionUsers()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.readPermissionUsers()
    this.getCompanyAdminArtist()
  }
}
</script>

<style scoped>
.social-icon {
  width: 25px;
  height: 25px;
  margin-bottom: 3px;
}
</style>
